import type { LayoutApiByStructure } from '../createLayoutApi_structure';
import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';
import type { CompPointersApi } from '#packages/compPointers';
export function createLayoutScaleApi({
  layoutApi_structure,
}: {
  editorAPI: EditorAPI;
  compPointersApi: CompPointersApi;
  layoutApi_structure: LayoutApiByStructure;
}) {
  function updateFontScale_structure(
    compRefOrRefs: CompRef | CompRef[],
    scale: number,
  ) {
    layoutApi_structure.updateAndAdjustLayout(compRefOrRefs, {
      scale,
    });
  }

  return {
    updateFontScale: updateFontScale_structure,
  };
}

export type LayoutScaleApi = ReturnType<typeof createLayoutScaleApi>;
